import { h } from 'preact';
import { useEffect, useMemo } from 'preact/hooks';

import Store from '../../stores/Store';
import { Route, route } from 'preact-router';
const RouteGuard = props => {
  const store = useMemo(() => new Store(), []);

  useEffect(() => {
    if (!store.isLoggedIn()) route('/logout', true);
  }, []);

  return <Route {...props} />;
};

export default RouteGuard;
